"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClient = createClient;
var _routing = require("../../routing.cjs");
function createClient(api) {
  async function list() {
    const url = _routing.routing.accounts;
    return api.get(url);
  }
  async function create(payload) {
    const url = _routing.routing.accounts;
    return api.post(url, {
      payload
    });
  }
  async function update(id, payload) {
    const url = `${_routing.routing.accounts}/${id}`;
    return api.patch(url, {
      payload
    });
  }
  return {
    list,
    create,
    update
  };
}